// One Revert VM runner shared by the tray and the drawers. See revertRuns.spec.md (RVR-FR-006)
// See RevertVmRunnerContext.spec.md for RVRC-FR-001, RVRC-FR-002
import type { ReactNode } from 'react'
import { createContext, useContext, useMemo, useState } from 'react'
import useRevertVmRunner, { type RevertVmRunner } from './useRevertVmRunner'

// RVR-FR-006: the tray hides while a Revert VM drawer is open so it never covers the drawer
// footer. The drawer flips this on mount and back on unmount.
export interface RevertVmRunnerContextValue extends RevertVmRunner {
  drawerOpen: boolean
  setDrawerOpen: (open: boolean) => void
}

const RevertVmRunnerContext = createContext<RevertVmRunnerContextValue | null>(null)

export const RevertVmRunnerProvider = ({ children }: { children: ReactNode }) => {
  const runner = useRevertVmRunner()
  const [drawerOpen, setDrawerOpen] = useState(false)
  const value = useMemo(() => ({ ...runner, drawerOpen, setDrawerOpen }), [runner, drawerOpen])
  return <RevertVmRunnerContext.Provider value={value}>{children}</RevertVmRunnerContext.Provider>
}

export const useRevertVmRunnerContext = (): RevertVmRunnerContextValue => {
  const runner = useContext(RevertVmRunnerContext)
  if (!runner) {
    throw new Error('useRevertVmRunnerContext must be used inside RevertVmRunnerProvider')
  }
  return runner
}
